/**
 * Checks if any of the given error messages are related to tracked cards.
 * @param {string|string[]} errorMessages
 * @returns {boolean}
 */
export default function hasTrackedCardsErrorMessage(errorMessages) {
    if (typeof errorMessages === 'string') {
        errorMessages = [errorMessages];
    }
    if (!Array.isArray(errorMessages)) return false;
    const trackedCardsKeywords = [
        'time-tracked'
    ];
    
    return errorMessages.some(errorMessage =>
        typeof errorMessage === 'string' &&
        trackedCardsKeywords.some(keyword =>
            errorMessage.toLowerCase().includes(keyword)
        )
    );
}